import { clearCurrentToken } from "functions";

export default function logout() {
    clearCurrentToken();
    window.location.href = "/";
}
